import {
  CheckCircleOutlined,
  MinusCircleOutlined,
  SyncOutlined,
} from '@ant-design/icons';
import { Tag } from 'antd';
import React from 'react';

import { EStatus } from '@common/types';

type TStatusTagProps = {
  status: keyof typeof EStatus;
};

export const StatusTag = ({ status }: TStatusTagProps): React.JSX.Element => {
  let tag = <Tag color="default">{status}</Tag>;
  switch (status) {
    case EStatus.ACTIVE:
      tag = (
        <Tag color="success" icon={<CheckCircleOutlined />}>
          {status}
        </Tag>
      );
      break;
    case EStatus.PROCESSING:
      tag = (
        <Tag color="processing" icon={<SyncOutlined spin />}>
          {status}
        </Tag>
      );
      break;
    case EStatus.DEACTIVATED:
      tag = (
        <Tag color="default" icon={<MinusCircleOutlined />}>
          {status}
        </Tag>
      );
      break;
  }

  return tag;
};
